<template>
    <div>
        <div v-for="parameter in parameters">
            <parameter-input v-model="internalValue[parameter.key]"
                             :parameter="parameter"
                             :parameter-group-identifier="parameterGroupIdentifier"
                             :label="$t(`frontend-parameters.parameters.${parameterGroupIdentifier}.${subGroupIdentifier}.${parameter.key}.title`)"
            />
        </div>
    </div>
</template>

<script>
import ParameterInput from "@/components/ParameterInput.vue";

export default {
    name: 'ParameterGenericSubGroup',
    components: {ParameterInput},

    props: {
        value: {},
        parameters: {required: true},
        parameterGroupIdentifier: {required: true},
        subGroupIdentifier: {required: true},
    },

    mounted() {
    },

    data() {
        return {
            internalValue: structuredClone(this.value),
        }
    },

    computed: {
    },

    watch: {
        internalValue: {
            deep: true,
            handler() {
                this.$emit('input', this.internalValue)
            },
        }
    }
}
</script>
